import { ByteChannel3cxdguezl3lu7 as ByteChannel } from './ByteChannel.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function attachWriterJob(_this__u8e3s4, writerJob) {
  var tmp = writerJob.channel_1;
  var tmp0_safe_receiver = tmp instanceof ByteChannel() ? tmp : null;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.invokeOnClose_agzauw_k$((cause) => {
      var tmp;
      if (!(cause == null)) {
        _this__u8e3s4.cancel_9i2dv0_k$(cause);
        tmp = Unit_instance;
      }
      return Unit_instance;
    });
  }
}
//region block: exports
export {
  attachWriterJob as attachWriterJob2dr3tee7atoa9,
};
//endregion

//# sourceMappingURL=ByteChannelUtils.mjs.map
